import {useMutation} from 'react-query';
import deleteSaleAgent from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IUseDeleteImageProfileProps {
  refetchGetSaleAgentList?: () => void;
}
const useDeleteSaleAgent = ({
  refetchGetSaleAgentList,
}: IUseDeleteImageProfileProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (guid: string) => {
      return deleteSaleAgent(guid);
    },
    onSuccess: () => {
      refetchGetSaleAgentList && refetchGetSaleAgentList();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useDeleteSaleAgent;
